import axios from 'axios'

import * as types from '../mutation-types'
import { createTheParametersOfTheUrl } from '../../plugins/helper'

const doToArrayObject = ({ data }) => {
  const arr = []
  let i = 0
  for (i in data) {
    if (data.hasOwnProperty(i)) {
      arr.push({ value: data[i].id, text: `${data[i].name}(${data[i].email})` })
    }
  }

  return arr
}

// state
export const state = {
  loading: true,
  users: [],
  error: null,
  loadingUser: true,
  user: null,
  errorUser: null,
}

// mutations
export const mutations = {
  [types.GET_USERS_START] (state) {
    state.loading = true
    state.users = []
    state.error = null
  },

  [types.GET_USERS_SUCCESS] (state, { data }) {
    state.loading = false
    state.users = doToArrayObject(data)
    state.error = null
  },

  [types.GET_USERS_ERROR] (state, { error }) {
    state.loading = false
    state.users = []
    state.error = error
  },

  [types.GET_USER_START] (state) {
    state.loadingUser = true
    state.user = null
    state.errorUser = null
  },

  [types.GET_USER_SUCCESS] (state, { data }) {
    state.loadingUser = false
    state.user = data.data
    state.errorUser = null
  },

  [types.GET_USER_ERROR] (state, { error }) {
    state.loadingUser = false
    state.user = null
    state.errorUser = error
  },
}

export const actions = {
  async getUsers ({ commit }, payload) {
    try {
      commit(types.GET_USERS_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/administrations/users/lists${href}`)

      commit(types.GET_USERS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_USERS_ERROR, { error: null })
    }
  },

  async getUser ({ commit }, userId) {
    try {
      commit(types.GET_USER_START)

      const { data } = await axios.get(`/api/administrations/users/${userId}`)

      commit(types.GET_USER_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_USER_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingUsers: state => state.loading,
  users: state => state.users,
  errorUsers: state => state.error,
  loadingUser: state => state.loadingUser,
  user: state => state.user,
  errorUser: state => state.errorUser,
}
